import { TRootState }    from 'Redux/Reducers';
import { arrayContains } from 'Utils';
import Actions           from 'Redux/Actions';

export const isInvoiceLoading = (state: TRootState): boolean =>
  arrayContains(state.organizer.openRequests, [
    Actions.findInvoiceRequest.type,
    Actions.findInvoicesRequest.type,
    Actions.sendInvoicePdfRequest.type,
    Actions.sendTicketsFromInvoiceRequest.type,
    Actions.updateInvoiceRequest.type,
  ]);
